import { SpringConfigsType } from 'interfaces/generic';

type TZaConfigs = Required<
  Pick<
    SpringConfigsType,
    | 'SHOW_ACCOUNT_STATEMENT'
    | 'SHOW_CASINO_TIMER_NET_WIN'
    | 'CALCULATE_BETS_WITHOUT_TAXES'
    | 'DOC_NUMBER_REGISTRATION_AGE_OVER_18'
    | 'DOC_NUMBER_REGISTRATION_PASSPORT_STRICT_FORMAT'
  >
>;

export default {
  SHOW_ACCOUNT_STATEMENT: true,
  SHOW_CASINO_TIMER_NET_WIN: true,
  CALCULATE_BETS_WITHOUT_TAXES: true,
  DOC_NUMBER_REGISTRATION_AGE_OVER_18: true,
  DOC_NUMBER_REGISTRATION_PASSPORT_STRICT_FORMAT: true
} as TZaConfigs;
